export const saveNowEventName = "nkriz-save-now";

type SaveNowDetail = {
  waitUntil: (work: void | Promise<void>) => void;
};

export async function flushOpenEditors(): Promise<void> {
  const pending: Promise<void>[] = [];
  window.dispatchEvent(new CustomEvent<SaveNowDetail>(saveNowEventName, {
    detail: { waitUntil: (work) => pending.push(Promise.resolve(work)) }
  }));
  await Promise.all(pending);
}

export function saveNowWork(event: Event, work: void | Promise<void>): void {
  (event as CustomEvent<SaveNowDetail>).detail.waitUntil(work);
}
